module.exports = __webpack_public_path__ + "img/doors.a86d12cc.svg";